import { CloseButtonProps } from './models';
import styled from 'styled-components';
import * as styles from './styles';
import React, { FC } from 'react';

export const CloseButton = styled<FC<CloseButtonProps>>(({ className, onClick, dataTestId, size }) => {
  return (<div {...{ className, onClick, size, 'data-testid': dataTestId }} />);
}
)`
  ${styles.CloseButton}
`;

CloseButton.defaultProps = {
  size: 30,
};
